<script lang="ts">
	import { GeoJSON, LineLayer } from 'svelte-maplibre';

	interface Props {
		coordinates: number[][][];
	}

	const { coordinates }: Props = $props();
</script>

<GeoJSON data={{ type: 'Polygon', coordinates }}>
	<LineLayer
		layout={{ 'line-cap': 'round', 'line-join': 'round' }}
		paint={{
			'line-width': 2,
			'line-dasharray': [2, 2],
			'line-color': '#27509B',
		}}
	/>
</GeoJSON>
